import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './components/Home';
import About from './components/About';
import Contact from './components/Contact';
import Chemical from './components/Chemical';
import Mechanical from './components/Mechanical';
import Footer from './components/Footer';
import APITest from './components/APITest';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/chemical" element={<Chemical />} />
          <Route path="/mechanical" element={<Mechanical />} />
          <Route path="/api-test" element={<APITest />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;